module.exports = __webpack_public_path__ + "images/800x800_Individual_0000s_0015_Suso_Apple-&-Cherry_1.png";